// When user signs into app, we're going to authenticate them and get the Twilio
// identity, so Twilio can then operate on behalf of that user.

import * as User from '../user';
import ms        from 'ms';
import onChange  from '../util/on_change';
import rollbar   from '../rollbar';
import store     from '../store';
import Twilio    from  'twilio-chat';
import xhr       from 'xhr';


let clientPromise;


// When user signs into app, immediately authenticate against Twilio.
// Twilio starts tracking online presence for this user.
onChange(store, User.getUserID, function(_, userID) {
  if (userID)
    getTwilioClient();
});

// When user signs out of app, log them out from Twilio.
// Twilio stops tracking online presence for this user.
onChange(store, User.isSignedOut, async function(_, isSignedOut) {
  if (isSignedOut) {
    const client = await clientPromise;
    client.shutdown();
  }
});

async function getToken() {
  const { jwtToken } = User.getAccessToken(store.getState());

  return new Promise(function(resolve, reject) {
    xhr({
      url:     `${API_URL}/me/twilio_chat`,
      method:  'GET',
      timeout: ms('5s'),
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    }, function(error, response, body) {
      if (error) {
        rollbar.error(error);
        reject(error);
      }
      try {
        const { token } = JSON.parse(body);
        resolve(token);
      } catch (parseJsonError) {
        reject(parseJsonError);
      }
    });
  });
}

async function getTwilioClient() {
  if (!clientPromise)
    clientPromise = createTwilioClient();

  return clientPromise;
}

async function createTwilioClient() {
  const token    = await getToken();
  const isDev    = (process.env.NODE_ENV === 'development');
  const logLevel = isDev ? 'info' : 'silent';
  const client   = await Twilio.create(token, { logLevel });

  client.on('tokenAboutToExpire', async function() {
    const newToken = await getToken();
    client.updateToken(newToken);
  });

  return client;
}

export default getTwilioClient;
